import { Navigate } from "react-router-dom";
import { useAuth } from "@/core/auth";
import { useGetMyUser } from "@/user/query";
import { isApOnly } from "@/user/utils";
import { LoadingSpinner } from "./loading-spinner";
import { Stack } from "./ui/stack";

export const PublicRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const { data: user, isLoading: isUserLoading } = useGetMyUser();

  if (isLoading || (isAuthenticated && isUserLoading)) {
    return (
      <Stack fullWidth className="h-full" justify="center" align="center">
        <LoadingSpinner />
      </Stack>
    );
  }

  // Let the protected route recover an authenticated session with no user.
  if (isAuthenticated && (!user || isApOnly(user.role))) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
